import { render, staticRenderFns } from "./List.vue?vue&type=template&id=144dcdd0&scoped=true&"
import script from "./List.vue?vue&type=script&lang=js&"
export * from "./List.vue?vue&type=script&lang=js&"
import style0 from "./List.vue?vue&type=style&index=0&id=144dcdd0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "144dcdd0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('144dcdd0')) {
      api.createRecord('144dcdd0', component.options)
    } else {
      api.reload('144dcdd0', component.options)
    }
    module.hot.accept("./List.vue?vue&type=template&id=144dcdd0&scoped=true&", function () {
      api.rerender('144dcdd0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/profile/list/components/List.vue"
export default component.exports